var closeMobileMenu;

prepMobileMenu = () => {
  const hammyTrigger = document.querySelector('.hammy');
  const hammyLines = hammyTrigger.querySelectorAll("span");
  const close = document.querySelector('#main-navigation .close');
  const closeLinesWrapper = close.querySelectorAll('div');
  const closeLines = close.querySelectorAll('span');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeTrigger = mobileMenu.querySelector('.close');

  gsap.set(closeLinesWrapper[0], { xPercent: -50, yPercent: -50, rotate: 45 })
  gsap.set(closeLinesWrapper[1], { xPercent: -50, yPercent: -50, rotate: -45 })

  let mobileMenuOpen = false;

  let openMobileMenu = () => {
    if (mobileMenuOpen) { return; }
    gsap.delayedCall(0.32, () => {
      // hideSearchTray();
    });
    gsap.to(mobileMenu, 0.35, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
    gsap.to(mobileMenu, 0.85, { x: 0, ease: Expo.easeOut, force3D: true });
    gsap.to(hammyLines, 0.35, { scaleX: 0, transformOrigin: "100% 50%", ease: Sine.easeOut, stagger: 0.12, force3D: true });
    gsap.to(closeLines[0], 0.35, { scaleX: 1, transformOrigin: "0% 50%", ease: Sine.easeOut, delay: 0.25, force3D: true });
    gsap.to(closeLines[1], 0.35, { scaleX: 1, transformOrigin: "0% 50%", ease: Sine.easeOut, delay: 0.35, force3D: true });
    mobileMenuOpen = true;

    if ($scroll) {
      $scroll.lockScroll()
    }
  };

  closeMobileMenu = () => {
    if (!mobileMenuOpen) { return; }
    let openDrawer = mobileMenu.querySelector('.drawer.open');
    if (openDrawer) {
      gsap.delayedCall(0.3, () => {
        openDrawer.click();
      });

    }
    gsap.to(mobileMenu, 0.55, { autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
    gsap.to(mobileMenu, 0.85, { x: -70, ease: Expo.easeOut, force3D: true });
    gsap.to(hammyLines, 0.25, { scaleX: 1, transformOrigin: "100% 50%", ease: Sine.easeOut, stagger: 0.06, delay: 0.1, force3D: true });
    gsap.to(closeLines[0], 0.25, { scaleX: 0, transformOrigin: "0% 50%", ease: Sine.easeOut, force3D: true });
    gsap.to(closeLines[1], 0.25, { scaleX: 0, transformOrigin: "0% 50%", ease: Sine.easeOut, force3D: true });
    mobileMenuOpen = false;

    if ($scroll) {
      $scroll.unlockScroll()
    }
  };

  hammyTrigger.addEventListener('click', () => {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  closeTrigger.addEventListener('click', () => {
    closeMobileMenu();
  });
};